import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { retry } from 'rxjs/operators';
import { DialogEditUserComponent } from './admin/dialog-edit-user.component';
import { AppService } from './app.service';
import { DialogEditTextComponent } from './dialog-edit-text.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  constructor(private serv: AppService, public dialog: MatDialog, private _snackbar: MatSnackBar) { }

  categories = []
  gearAddEditGuideText = ""
  welcomeGuideText = ""
  homeLinkHref = "/"
  homeLinkText = "ShareIt"

  iframeMode = false

  systemType = "udlaan"

  mailRootURL = ""
  mailAcceptedText = ""
  mailRejectedText = ""

  users = []
  usersObj = {}

  

  ngOnInit(): void {
    this.serv.adminInit().subscribe(ret => {
      this.categories = ret['categories']

      this.users = ret['users']
      for (let u of this.users) {
        this.usersObj[u['id']] = u
      }
      
      if ('gear_edit_guide' in ret['conf'])
         this.gearAddEditGuideText = ret['conf']['gear_edit_guide']

      if ('welcome_guide' in ret['conf'])
        this.welcomeGuideText = ret['conf']['welcome_guide']

      if ('home_link_href' in ret['conf'])
        this.homeLinkHref = ret['conf']['home_link_href']

      if ('home_link_text' in ret['conf'])
        this.homeLinkText = ret['conf']['home_link_text']
      if ('mail_root_url' in ret['conf'])
        this.mailRootURL = ret['conf']['mail_root_url']
      if ('mail_accepted_text' in ret['conf'])
        this.mailAcceptedText = ret['conf']['mail_accepted_text']
      if ('mail_rejected_text' in ret['conf'])
        this.mailRejectedText = ret['conf']['mail_rejected_text']

      if ('iframe_mode' in ret['conf'])
        this.iframeMode = ret['conf']['iframe_mode']

      if ('system_type' in ret['conf'])
        this.systemType = ret['conf']['system_type']
    })
  }


  editUser(user: object) {
    const dialogRef = this.dialog.open(DialogEditUserComponent, {width: "420px", data: {user: user}})

    dialogRef.afterClosed().subscribe(ret => {
      if (ret) {
        this._snackbar.open("Bruger opdateret!", "Luk", {
          duration: 5000,
        });
        this.ngOnInit()
      }
    })
  }
  removeUser(id: string) {
    let username = this.usersObj[id]['username']
    if (confirm('Er du sikker på at du vil slette brugeren ${username} ?')) {
      this.serv.adminRemoveUser(+id).subscribe(_ => {
        this._snackbar.open("Bruger slettet!", "Luk", {
          duration: 5000,
        });
        this.ngOnInit()
      })
    }
  }

  setVerified(id: number, checked: boolean) {
    this.serv.adminSetVerified(id, checked).subscribe(ret => {
      if (ret['result']) {
        this._snackbar.open(checked ? "Bruger er sat til 'verificeret'!" : "Bruger er sat til 'uverificeret'!", "Luk", {
          duration: 5000,
        });
      }
    })
  }


  addCategory() {
    let name = prompt("Hvad skal kategorien hedde?")
    if (name) {
      this.serv.adminAddCategory(name).subscribe(_ => {
        this.ngOnInit()
      })
    }
  }

  removeCategory(id: number) {
    if (confirm("Er du sikker på at du vil slette denne kategori?")) {
      this.serv.adminRemoveCategory(id).subscribe(_ => {
        this.ngOnInit()
      })
    }
  }

  editCategory(id: number, oldName: string) {
    let name = prompt("Hvad skal kategorien omdøbes til?", oldName)
    if (name) {
      this.serv.adminEditCategory(id, name).subscribe(_ => {
        this.ngOnInit()
      })
    }
  }

  editHomeLinkHref() {
    let href = prompt("Hvad skal linket pege på?", this.homeLinkHref)
    if (href) {
      this.serv.adminEditConf({home_link_href: href}).subscribe(_ => {
        this.ngOnInit()
      })
    }
  }
  editHomeLinkText() {
    let text = prompt("Hvilken tekst skal der stå?", this.homeLinkText)
    if (text) {
      this.serv.adminEditConf({home_link_text: text}).subscribe(_ => {
        this.ngOnInit()
      })
    }
  }


  
  editWelcomeGuide() {
    const dialogRef = this.dialog.open(DialogEditTextComponent, {width: "75%", data: {title: "Rediger velkomst vejledning", text: this.welcomeGuideText}})
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.serv.adminEditConf({welcome_guide: res}).subscribe(_ => {
          this._snackbar.open("Vedledende tekst på forsiden er blevet opdateret!", "Luk", {
            duration: 5000,
          });
          this.ngOnInit()
        })
      }
    })
  }

  editGearAddEditGuide() {
    const dialogRef = this.dialog.open(DialogEditTextComponent, {width: "75%", data: {title: "Rediger vejledende tekst til tilføjelse/redigering af udstyr", text: this.gearAddEditGuideText}})

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.serv.adminEditConf({gear_edit_guide: res}).subscribe(_ => {
          this._snackbar.open("Vedledende tekst til tilføjelse/redigering af udstyr er blevet opdateret!", "Luk", {
            duration: 5000,
          });
          this.ngOnInit()
        })
      }
    })
  }
  editMailRootURL() {
    /*
    const dialogRef = this.dialog.open(DialogEditTextComponent, {width: "75%", data: {title: "Rediger rod-URL til denne webapplikation (bruges til email)", text: this.gearAddEditGuideText}})

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.serv.adminEditConf({mail_root_url: res}).subscribe(_ => {
          this._snackbar.open("Rod URL ændret!", "Luk", {
            duration: 5000,
          });
          this.ngOnInit()
        })
      }
    })*/
    let text = prompt("Hvad er rod-URL'en til webapplikationen?", this.mailRootURL)
    if (text) {
      this.serv.adminEditConf({mail_root_url: text}).subscribe(_ => {
        this.ngOnInit()
      })
    }

  }

  editMailRejectedText() {
    const dialogRef = this.dialog.open(DialogEditTextComponent, {width: "75%", data: {title: "Rediger supplerende tekst til afvisnings-mails", text: this.mailRejectedText}})

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.serv.adminEditConf({mail_rejected_text: res}).subscribe(_ => {
          this._snackbar.open("'Afvist' supplerende email tekst opdateret!", "Luk", {
            duration: 5000,
          });
          this.ngOnInit()
        })
      }
    })
  }

  editMailAcceptedText() {
    const dialogRef = this.dialog.open(DialogEditTextComponent, {width: "75%", data: {title: "Rediger supplerende tekst til accept-mails", text: this.mailAcceptedText}})

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.serv.adminEditConf({mail_accepted_text: res}).subscribe(_ => {
          this._snackbar.open("'Accepteret' supplerende email tekst opdateret!", "Luk", {
            duration: 5000,
          });
          this.ngOnInit()
        })
      }
    })
  }

  deleteOldReservations() {
    if (confirm("Er du sikker på at du vil slette udløbne reservationer fra databasen?")) {
      /*this.serv.adminGetZipFile().subscribe(_ => {
        window.open("assets/admin/get_zip.php")
      })
      */
     this.serv.adminDeleteOldReservations().subscribe(ret => {
       if (ret['result']) {
        this._snackbar.open("Udløbne reservationer er blevet slettet!", "Luk", {
          duration: 5000,
        });
       }
     })
    }
  }

  setIframeMode(checked:boolean) {
    this.iframeMode = checked

    this.serv.adminEditConf({iframe_mode: checked}).subscribe(_ => {
      this._snackbar.open("'Iframe mode' er "+(checked ? "slået til" : "slået fra")+"!", "Luk", {
        duration: 5000,
      });
      this.ngOnInit()
    })
  }

  updateSystemType() {
    this.serv.adminEditConf({system_type: this.systemType}).subscribe(_ => {
      this._snackbar.open("System type er ændret!", "Luk", {
        duration: 5000,
      });
      this.ngOnInit()
    })
  }
}
